// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 4V2H5V6H6V14H3V13H1V22H11V13H13V22H23V13H21V14H18V6H19V2H17V4H15V2H13V4H11V2H9V4H7ZM11.0039 7.99805V10.002H9V7.99805H11.0039ZM15.0039 7.99805V10.002H13V7.99805H15.0039Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-castle-1-filled')
export default class Castle1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'castle-1-filled',
    }
  }
}
